<!--<c-header class="mb-4 d-print-none" position="sticky">-->
  <ng-container *transloco="let t">
    <c-container [fluid]="true">
      <button
        toggle="visible"
        cHeaderToggler
        [cSidebarToggle]="sidebarId"
        class="ps-1"
        *ngIf="okService.view.show_main_menu"
      >
        <svg cIcon
          name="cilMenu"
          size="lg"
        ></svg>
      </button>

      <c-header-nav class="d-lg-flex me-auto" [class.d-none]="okService.view.show_main_menu">

        <ng-container *ngIf="!okService.view.show_main_menu">


        <c-nav-item>
          <a cNavLink routerLink="/home" routerLinkActive="active">
            {{ t('Home') }}
          </a>
        </c-nav-item>

        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false">{{ t('Management') }}</a>
          <ul class="dropdown-menu">
            <li><a cNavLink routerLink="/mgmt/workers/workers" routerLinkActive="active">{{ t('Workers') }}</a></li>
            <li *ngIf="okService.isAdmin() || okService.hasMonitorAccess('monitors','index')"><a cNavLink routerLink="/mgmt/monitors/monitors" routerLinkActive="active">{{ t('Monitors') }}</a></li>
            <li *ngIf="okService.isFDCPrivacy() && !(okService.isAdmin() || okService.hasMonitorAccess('monitors','index'))"><a cNavLink routerLink="/mgmt/monitors/monitors-privacy" routerLinkActive="active">{{ t('Monitors') }}</a></li>
            <li *ngIf="okService.hasFeature('groups') && (okService.isAdmin() || okService.hasMonitorAccess('groups','index'))"><a cNavLink routerLink="/mgmt/groups/groups" routerLinkActive="active">{{ t('Groups') }}</a></li>
            <li *ngIf="okService.settings && okService.settings.arc_on && okService.isAdmin()"><a cNavLink routerLink="/mgmt/monitoring" routerLinkActive="active">{{ t('Safety Monitoring Center') }}</a></li>
            <li *ngIf="okService.isAdmin() && okService.hasFeature('out_of_hours')"><a cNavLink routerLink="/mgmt/outofhours" routerLinkActive="active">{{ t('Out of Hours') }}</a></li>
            <li *ngIf="okService.isAdmin() && okService.hasFeature('alert_loops')"><a cNavLink routerLink="/mgmt/alertloops/alertloops" routerLinkActive="active">{{ t('Alert Loops') }}</a></li>
            <li *ngIf="okService.isAdmin() && okService.hasFeature('map_zones')"><a cNavLink routerLink="/mgmt/safetyzones" routerLinkActive="active">{{ t('Map Zones') }}</a></li>
            <li *ngIf="okService.isAdmin() && okService.hasFeature('threat_zones', false)"><a cNavLink routerLink="/mgmt/threats" routerLinkActive="active">{{ t('Alert Zone Intelligence') }}</a></li>
            <li *ngIf="okService.isAdmin() && okService.isGeotab()"><a cNavLink routerLink="/mgmt/vehicles" routerLinkActive="active">{{ t('Vehicles') }}</a></li>
            <li *ngIf="okService.isAdmin() && okService.hasFeature('zoleo')"><a cNavLink routerLink="/mgmt/devices" routerLinkActive="active">{{ t('Devices') }}</a></li>
            <li *ngIf="okService.hasFeature('send_messages') && (okService.isAdmin() || okService.hasMonitorAccess('mass_notifications','send'))"><a cNavLink routerLink="/mgmt/send-messages" routerLinkActive="active">{{ t('Mass Notifications') }}</a></li>
            <li *ngIf="okService.hasFeature('team_broadcast', false) && (okService.isAdmin() || okService.hasMonitorAccess('broadcasts','index'))"><a cNavLink routerLink="/mgmt/broadcasts" routerLinkActive="active">{{ t('Team Broadcast') }}</a></li>
            <li *ngIf="okService.isAdmin() && okService.hasFeature('app_links')"><a cNavLink routerLink="/mgmt/app-links" routerLinkActive="active">{{ t('Safety Links') }}</a></li>
            <li *ngIf="okService.isAdmin() && (okService.from_admin || (okService.settings && okService.settings.id==2296))"><a cNavLink routerLink="/mgmt/workers/massdelete" routerLinkActive="active">{{ t('Delete Workers') }}</a></li>
         </ul>
        </li>

        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false">{{ t('Reports & Logs') }}</a>
          <ul class="dropdown-menu">
            <li><a cNavLink routerLink="/reports/actions" routerLinkActive="active">{{ t('Actions') }}</a></li>
            <li><a cNavLink routerLink="/reports/alerts" routerLinkActive="active">{{ t('Alerts') }}</a></li>
            <li><a cNavLink routerLink="/mgmt/shifts/shifts" routerLinkActive="active">{{ t('Shifts') }}</a></li>
            <li><a cNavLink routerLink="/reports/locations" routerLinkActive="active">{{ t('Locations') }}</a></li>
            <li *ngIf="okService.hasFeature('timed_activity')"><a cNavLink routerLink="/reports/activities" routerLinkActive="active">{{ t('Timed Activities') }}</a></li>
            <li *ngIf="!okService.isExtendedPrivacy() && okService.hasFeature('timesheets')"><a cNavLink routerLink="/reports/timesheets" routerLinkActive="active">{{ t('Timesheets') }}</a></li>
            <li *ngIf="!okService.isExtendedPrivacy() && okService.isAdmin() && okService.hasFeature('safety_awards')"><a cNavLink routerLink="/awards/awards-home" routerLinkActive="active">{{ t('Safety Awards') }}</a></li>
            <li *ngIf="!okService.isExtendedPrivacy() && okService.hasFeature('worker_reports')"><a cNavLink routerLink="/reports/worker-reports" routerLinkActive="active">{{ t('Reports') }}</a></li>
            <li *ngIf="!okService.isExtendedPrivacy() && okService.isAdmin() && okService.hasFeature('worker_reports')"><a cNavLink routerLink="/reports/reports-scheduling" routerLinkActive="active">{{ t('Reports Scheduling') }}</a></li>
            <li *ngIf="!okService.isExtendedPrivacy() && okService.isAdmin() && okService.hasFeature('start_end_shift')"><a cNavLink routerLink="/reports/shift-upload" routerLinkActive="active">{{ t('Shift Upload/Export') }}</a></li>
          </ul>
        </li>

        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false">{{ t('Settings') }}</a>
          <ul class="dropdown-menu">

            <li><a cNavLink routerLink="/settings/profile" routerLinkActive="active">{{ t('Profile') }}</a></li>

            <li *ngIf="okService.isAdmin()"><a cNavLink routerLink="/settings/settings" routerLinkActive="active">{{ t('Company Settings') }}</a></li>
            <li *ngIf="okService.showExtraFeaturesMenu() && okService.isAdmin() && okService.billing && (!okService.billing.plan.hide_extra_features || okService.isFromAdmin() || (okService.billing.live && okService.isSuperAdmin()))"><a cNavLink routerLink="/settings/features" routerLinkActive="active">{{ t('Extra Features') }}</a></li>
            <li *ngIf="okService.isAdmin() && okService.hasFeature('escalation_procedure')"><a cNavLink routerLink="/settings/escalation" routerLinkActive="active">{{ t('Escalation Procedure') }}</a></li>
            <li *ngIf="okService.isAdmin() && okService.hasFeature('live_monitoring')"><a cNavLink routerLink="/settings/live" routerLinkActive="active">{{ t('Call Center') }}</a></li>
            <li *ngIf="okService.isAdmin() && okService.hasFeature('what3words')"><a cNavLink routerLink="/settings/w3w" routerLinkActive="active">{{ t('what3words') }}</a></li>
            <li *ngIf="okService.isAdmin() && okService.hasFeature('learning_center')"><a cNavLink routerLink="/mgmt/learning-center" routerLinkActive="active">{{ t('Learning Center') }}</a></li>
            <li *ngIf="okService.isAdmin()"><a cNavLink routerLink="/account" routerLinkActive="active">{{ t('Account') }}</a></li>
            <li><a cNavLink routerLink="/settings/help" routerLinkActive="active">{{ t('Help & Docs') }}</a></li>


          </ul>
        </li>

      </ng-container>

        <c-nav-item style="padding-left:20px;" *ngIf="okService.loading">
          <a cNavLink><div><i class="fa-solid fa-spinner fa-spin"></i>{{ t(' Please wait') }}</div></a>
        </c-nav-item>

        @if(okService.settings && okService.view.show_main_menu && (okService.isFromAdmin() || okService.isSuperAdmin())){

        <c-nav-item style="padding-left:20px;" class="text-center text-white fs-5">
          OKA{{okService.settings.id}} {{okService.settings.company_name}}
        </c-nav-item>

        }
        @else if(okService.settings && okService.me?.other_logins?.length > 0){

        <c-nav-item style="padding-left:20px;" class="text-center text-white fs-5">
          {{okService.settings.company_name}}
        </c-nav-item>

        }

      </c-header-nav>




    <c-header-nav class="ms-3">
      <ng-container *ngTemplateOutlet="newsDropdown"></ng-container>
    </c-header-nav>

    @if(!okService.isFromAdmin()){

      <!-- Account Switcher Dropdown -->
      <c-header-nav class="ms-3" *ngIf="okService.me?.other_logins?.length > 0">
        <div class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="accountSwitcherDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="fa-solid fa-building fa-lg"></i>
          </a>
          <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="accountSwitcherDropdown">
            <li>
              <h6 class="dropdown-header bg-light fw-semibold py-2">{{ t('Switch Account') }}</h6>
            </li>
            <li *ngFor="let login of okService.me.other_logins">
              <a class="dropdown-item pointer" (click)="switchAccount(login.id)">
                {{ login.company }}
              </a>
            </li>
          </ul>
        </div>
      </c-header-nav>

    }

    <ng-template #newsDropdown>
      <c-dropdown alignment="end" variant="nav-item" *ngIf="okService.news && okService.news.length > 0">
        <button
          cButton
          color=""
          [caret]="false"
          cDropdownToggle
          class="py-0 mr-3"

          (click)="okService.doDismiss('news_'+getNewsId())"
        >
        <i class="fa-solid fa-regular fa-bell fa-lg"></i>
        <span class="position-absolute top-0 start-99 translate-middle p-2 bg-success rounded-circle" *ngIf="!okService.isDismissed('news_'+getNewsId())">
          <span class="visually-hidden">New alerts</span>
        </span>
        </button>
        <ul cDropdownMenu class="pt-0 pr-5 w-auto">
          <li>
            <h6 cDropdownHeader class="bg-light fw-semibold py-2">{{ t('News and Updates') }}</h6>
          </li>
          <li></li>
          <ng-container *ngFor="let news of okService.news">
            <li>
              <a (click)="goToNews(news)" cDropdownItem class="pointer">
                <b>{{ news.title }}</b><br/>
                {{ news.notes }}
              </a>
            </li>
          </ng-container>

        </ul>
      </c-dropdown>
    </ng-template>



      <c-header-nav class="d-none d-md-flex">
        <c-nav-item class="ml-2">
          <a href="https://okalone.zendesk.com/hc/en-gb?utm_source=dashboard&utm_medium=dashboard&utm_campaign=dashboard" target="_blank" cNavLink>
            <svg cIcon name="cilInfo" size="lg"></svg>
          </a>
        </c-nav-item>
        <c-nav-item class="profile-nav-item">
          <a cNavLink>
            <div>
              <i class="fa fa-user" aria-hidden="true"></i>
              <span class="text-white"> {{okService.session.name}}</span>
            </div>
          </a>
        </c-nav-item>
      </c-header-nav>
      <c-header-nav class="ms-3">
        <ng-container *ngTemplateOutlet="userDropdown"></ng-container>
      </c-header-nav>

    <!-- </c-container>
    <c-header-divider></c-header-divider>
    <c-container [fluid]="true">
      <c-breadcrumb-router class="ms-2"></c-breadcrumb-router>
    </c-container>
  </ng-container> -->
  <!--</c-header>-->



  <ng-template #userDropdown>
    <c-dropdown alignment="end" variant="nav-item">
      <button
        cButton
        color=""
        [caret]="false"
        cDropdownToggle
        class="py-0"
      >
      <i class="fa-solid fa-sliders fa-lg"></i>


      </button>
      <ul cDropdownMenu class="pt-0 pr-5 w-auto">
        <ng-container>
          <li>
            <h6 cDropdownHeader class="bg-light fw-semibold py-2">{{ t('Language') }}</h6>
          </li>
          <li>
            <span cDropdownItem (click)="setLang('en')">
              <img src="https://flagcdn.com/w40/gb.png">
              {{ t('English') }}

              <fa-icon [icon]="['fas', 'star']" *ngIf="okService.langChoice == 'en'" ></fa-icon>
              <fa-icon [icon]="['far', 'star']" *ngIf="okService.langChoice != 'en'"></fa-icon>
            </span>
          </li>
          <li>
            <span cDropdownItem (click)="setLang('fr')">
              <img src="https://flagcdn.com/w40/fr.png">
              {{ t('French') }}

              <fa-icon [icon]="['fas', 'star']" *ngIf="okService.langChoice == 'fr'"></fa-icon>
              <fa-icon [icon]="['far', 'star']" *ngIf="okService.langChoice != 'fr'"></fa-icon>
            </span>
          </li>
          <li>
            <span cDropdownItem (click)="setLang('es')">
              <img src="https://flagcdn.com/w40/es.png">
              {{ t('Spanish') }}

              <fa-icon [icon]="['fas', 'star']" *ngIf="okService.langChoice == 'es'"></fa-icon>
              <fa-icon [icon]="['far', 'star']" *ngIf="okService.langChoice != 'es'"></fa-icon>
            </span>
          </li>
          <li>
            <span cDropdownItem (click)="setLang('pt')">
              <img src="https://flagcdn.com/w40/pt.png">
              {{ t('Portuguese') }}

              <fa-icon [icon]="['fas', 'star']" *ngIf="okService.langChoice == 'pt'"></fa-icon>
              <fa-icon [icon]="['far', 'star']" *ngIf="okService.langChoice != 'pt'"></fa-icon>
            </span>
          </li>
        </ng-container>
        <li>
          <h6 cDropdownHeader class="bg-light fw-semibold py-2">&nbsp;&nbsp;</h6>
        </li>
        <li></li>
        <li>
          <a routerLink="./settings/profile" cDropdownItem>
            <svg cIcon class="me-2" name="cilUser"></svg>
            {{ t('Profile') }}
          </a>
        </li>
        <li *ngIf="okService.isAdmin()">
          <a routerLink="./settings/settings" cDropdownItem>
            <svg cIcon class="me-2" name="cilSettings"></svg>
            {{ t('Settings') }}
          </a>
        </li>
        <li>
          <a href="https://www.okaloneworker.com/feature-request/" target="_feature_form" cDropdownItem>
            <svg cIcon class="me-2" name="cilFeaturedPlaylist"></svg>
            {{ t('Feature Request') }}
          </a>
        </li>
        <li *ngIf="!okService.view.show_main_menu">
          <a (click)="okService.goToDashboard()" cDropdownItem>
            <svg cIcon class="me-2" name="cilExternalLink"></svg>
            {{ t('Dashboard') }}
          </a>
        </li>
        <li>
          <a href="https://okalone.zendesk.com/hc/en-gb?utm_source=dashboard&utm_medium=dashboard&utm_campaign=dashboard" target="_blank" cDropdownItem>
            <svg cIcon name="cilInfo" size="lg"></svg>&nbsp;
             {{ t('Help') }}
          </a>
        </li>
        <li>
          <hr cDropdownDivider/>
        </li>
        <li>
          <a routerLink="./" cDropdownItem (click)="doLogout()">
            <svg cIcon class="me-2" name="cilAccountLogout"></svg>
            {{ t('Log Out') }}
          </a>
        </li>
        <li></li>
      </ul>
    </c-dropdown>
  </ng-template>

